export const CommentsInfo = () => {
  const regulamin = 'https://pl.canalplus.com/resources/dokumenty-one-portal/blog/Regulamin_CANALBlog_RODO.pdf';

  return (
    <div className="mb-[18px] px-0">
      <h2 className="m-0 text-[1.5rem] font-bold leading-[1.3] text-white px-0">
        Już przeczytane? Daj znać co myślisz o tym artykule!
      </h2>
      <p className="m-0 mt-0.5 text-[12px] leading-[16px] text-tertiary px-0">
        Komentując akceptujesz{' '}
        <a
          target="_blank"
          rel="noopener noreferrer"
          href={regulamin}
          className="font-semibold text-[#ec3654] no-underline hover:underline px-0"
        >
          regulamin
        </a>
        .
      </p>
    </div>
  );
};
